import React, { useEffect, useState } from "react";
import { SafeAreaView, StyleSheet, useWindowDimensions, View } from "react-native";
import Modal from "react-native-modal";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { useAccountContext } from "../../../hooks/useAccountContext";
import CustomButton from '../../CustomButton/CustomButton';
import CustomDropDownWithIcons from "../../CustomDropDownWithIcons/CustomDropDownWithIcons";
import CustomLabel from "../../CustomLabel/CustomLabel";
import { useTheme } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';
import { useAssessment } from "../../../hooks/useAssessment";
import { generateUniqueID } from "../../SurveyBuilderComponent/CreateSurvey/CreateSurveyFunctions";
import { showMessage } from "react-native-flash-message";

const PopUpAssm = ({
    toassmUi,
    handleSaveAssmInfo,
    handleSaveAssm,
    sectionEmpty,
    isSectionEmpty,
    setShowResponseScreen,
    setShowCreateGroup,
    setShowEditGroup,
    setShowMyAssessments,
    setShowAssessmentsAdmin,
    setShowCreateScreen,
    setShowEditScreen,
    setShowParticipationsScreen,
    setAssmUi,
    importPressed,
    setImportPressed,
    isEdit
}) => {

    const { user, clientApi, username } = useAuthContext();
    const { account } = useAccountContext();
    const { loadEveryAssessment, loadAssessmentByUI, postAssessment } = useAssessment();
    const { colors } = useTheme()
    const styles = makeStyles(colors);
    const { t } = useTranslation();
    const { width, height } = useWindowDimensions();
    const [PopUpvisible, setPopUpVisible] = useState(false);
    const [assmList, setAssmList] = useState([]);
    const [selected, setselected] = useState('');
    const [goToEdit, setGoToEdit] = useState(0);
    const [assm, setAssm] = useState({});
    const [sectionQuestionList, setSectionQuestionList] = useState([]);
    const [assmFromId, setAssmFromId] = useState({
        allowChangeOfAppraiser: false,
        appraisee: "",
        assmCompany: "",
        assmEmplUi: "",
        assmFromDate: "",
        assmGroupUi: "",
        assmSect: [],
        assmToDate: "",
        assmType: "",
        assmUi: "",
        description: "",
        employeeid: "",
        instructions: "",
        name: null,
        submitted: "",
        userid: null,
    });

    // * Map from ASSMTYPES
    const questionLineTypeToIndex = [
        { label: "Text", value: 2 },
        { label: "Slider", value: 21 },
        { label: "Essay", value: 6 },
        { label: "Scale", value: 5 },
        { label: "Scale", value: 12 },
        { label: "Boxes", value: 23 },
        { label: "TCC", value: 10 },
    ];


    useEffect(() => {
        loadEveryAssessment(clientApi, user.token, username).then(assm => {
            var tempAssm = []
            assm.map((assmItr) => {
                tempAssm.push({ label: assmItr.description, value: assmItr.assmUi })
            })
            setAssmList(tempAssm)
        }).catch(error => {
            console.log(error)
        });
    }, []);

    useEffect(() => {
        if (goToEdit === 1) {
            setAssmUi(toassmUi)
            setShowResponseScreen(0)
            setShowCreateGroup(0)
            setShowEditGroup(0)
            setShowMyAssessments(0)
            setShowAssessmentsAdmin(0)
            setShowCreateScreen(0)
            setShowEditScreen(1)
            setShowParticipationsScreen(0)
        }
    }, [goToEdit])

    useEffect(() => {
        // * No need to do anything here
    }, [width, height]);


    useEffect(() => {
        if (sectionQuestionList.length !== 0)
            postAssessment(
                clientApi,
                user.token,
                assm,
                sectionQuestionList,
                username,
                account.employeeId
            )
                .then((response) => {
                    if (response) {
                        showMessage({
                            message: t("common:saveSuccess"),
                            type: "success",
                            duration: 3000,
                        });
                        setAssmUi(toassmUi)
                        setShowResponseScreen(0)
                        setShowCreateGroup(0)
                        setShowEditGroup(0)
                        setShowMyAssessments(0)
                        setShowAssessmentsAdmin(0)
                        setShowCreateScreen(0)
                        setShowEditScreen(1)
                        setShowParticipationsScreen(0)
                    } else {
                        showMessage({
                            message: t("common:saveAssmFailMsg"),
                            type: "error",
                            duration: 3000,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error)
                    showMessage({
                        message: t("common:saveGroupFailMsg") + error,
                        type: "error",
                        duration: 3000,
                    });
                    if (!isCreate) {
                        setShowMyAssessments(1);
                    } else {
                        setShowAssessmentsAdmin(1);
                    }
                    setShowCreateScreen(0);
                    setShowEditScreen(0);
                    setShowEditGroup(0);
                    setShowResponseScreen(0);
                    setShowCreateGroup(0);
                    return false;
                });
    }, [sectionQuestionList]);

    useEffect(() => {
        getSectionQuestions()
    }, [assm]);

    const getSectionQuestions = () => {
        const newSectionQuestionList = [];
        for (var i = 0; i < assmFromId.assmSect.length; i++) {
            var sectionData = {
                id: generateUniqueID(),
                assm_header_id: toassmUi,
                section_name: assmFromId.assmSect[i].description,
                section_instructions: assmFromId.assmSect[i].instructions,
                section_url_img: assmFromId.assmSect[i].section_url_img,
                isSectionCover: assmFromId.assmSect[i].isSectionCover,
                graphAxis: assmFromId.assmSect[i].graphAxis,
                useOnGraph: assmFromId.assmSect[i].useOnGraph,
                section_required_yn: 0,
                section_order: assmFromId.assmSect[i].sectionId,
                section_quantitative: assmFromId.assmSect[i].isQuantitative,
                section_showResults: assmFromId.assmSect[i].isResult,
                section_hideComparison: assmFromId.assmSect[i].hideMeetingComparison,
                section_rotw: assmFromId.assmSect[i].readOnlyToWhom,
                section_rot: assmFromId.assmSect[i].readOnlyToWhom,
                section_weight: assmFromId.assmSect[i].weight,
                section_questions: [],
            };

            for (var j = 0; j < assmFromId.assmSect[i].assmQuest.length; j++) {
                const typeId = assmFromId.assmSect[i].assmQuest[j].assmQuestLineTypeId;
                const foundItem = questionLineTypeToIndex.find(item => item.value === typeId);
                const label = foundItem ? foundItem.label : "Text"
                var questionData = {
                    id: generateUniqueID(),
                    parent_id: "",
                    assm_section_id: sectionData.id,
                    question_subtext: "",
                    question_required_yn: assmFromId.assmSect[i].assmQuest[j].isRequired,
                    question_name: assmFromId.assmSect[i].assmQuest[j].description,
                    question_order: assmFromId.assmSect[i].assmQuest[j].questId,
                    input_type_id: typeId,
                    input_type_name: label,
                    quest_instructions: assmFromId.assmSect[i].assmQuest[j].instructions,
                    question_weight: assmFromId.assmSect[i].assmQuest[j].weight,
                    questImgUrl: assmFromId.assmSect[i].assmQuest[j].questImgUrl,
                    isQuestionCover: assmFromId.assmSect[i].assmQuest[j].isQuestionCover,
                    allow_mutiple_option_answers_yn: 0,
                    dependent_question_id: generateUniqueID(),
                    dependent_question_option_id: generateUniqueID(),
                    dependent_answer_id: generateUniqueID(),
                    option_group_id: "9EF9EC42-2E58-4CEF-93A4-4C3C63C2FBE0",
                    question_lines: [],
                    question_options: [
                        {
                            id: generateUniqueID(),
                            question_id: assmFromId.assmSect[i].assmQuest[j].questUI,
                            fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
                            fk_option_choice_name: "",
                            question_option_name: "",
                            option_order: 0,
                        },
                    ],
                };

                for (var k = 0; k < assmFromId.assmSect[i].assmQuest[j].assmQuestLine.length; k++) {
                    const typeId = assmFromId.assmSect[i].assmQuest[j].assmQuestLine[k].assmQuestLineTypeId;
                    const foundItem = questionLineTypeToIndex.find(item => item.value === typeId);
                    const label = foundItem ? foundItem.label : "Text"
                    var questionLineData = {
                        id: assmFromId.assmSect[i].assmQuest[j].assmQuestLine[k].questLineUI,
                        question_id: assmFromId.assmSect[i].assmQuest[j].assmQuestLine[k].questUI,
                        question_line_order: assmFromId.assmSect[i].assmQuest[j].assmQuestLine[k].lineId,
                        question_line_description: assmFromId.assmSect[i].assmQuest[j].assmQuestLine[k].description,
                        input_type_name: label,
                        input_type_id: typeId,
                        weight: assmFromId.assmSect[i].assmQuest[j].weight / assmFromId.assmSect[i].assmQuest[j].assmQuestLine.length,
                    };
                    questionData.question_lines.push(questionLineData);
                }
                sectionData.section_questions.push(questionData);
            }
            newSectionQuestionList.push(sectionData);
        }
        setSectionQuestionList(newSectionQuestionList)
    }

    const getAssm = () => {
        setAssm({
            id: toassmUi,
            assm_group_id: assmFromId.assmGroupUi,
            organization_id: "8F844600-801E-41C7-ABF0-27F80CDFB625",
            assm_title: assmFromId.description + " - COPY",
            assm_instructions: assmFromId.instructions,
            assm_from_date: assmFromId.assmFromDate,
            assm_to_date: assmFromId.assmToDate,
            assm_allowChangeOfAppraiser: assmFromId.allowChangeOfAppraiser,
            assm_type: assmFromId.assmType,
            assm_company: assmFromId.assmCompany,
            require_login: true,
        })
    }

    useEffect(() => {
        getAssm()
    }, [assmFromId]);

    useEffect(() => {
        if (importPressed === 1) {
            if (sectionEmpty) {
                if (handleSaveAssmInfo()) {
                    showPopUp();
                }
            } else {
                if (handleSaveAssm()) {
                    showPopUp();
                }
            }
            setImportPressed(0)
        }
    }, [sectionEmpty, importPressed]);

    const handleShowPopUp = () => {
        setImportPressed(1);
        isSectionEmpty();
    };

    const showPopUp = (e) => {
        setPopUpVisible(!PopUpvisible)
    }

    const loadAssessmentsByID = () => {
        loadAssessmentByUI(clientApi, user.token, username, selected)
            .then((respAssessmentByUi) => {
                setAssmFromId(respAssessmentByUi);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const handleCopyAssm = () => {
        loadAssessmentsByID();
    };

    return (
        <SafeAreaView style={styles.main}>
            <View style={styles.rowBtn}>
                <CustomButton
                    text={t('common:importAssm')}
                    onPress={isEdit ? () => { } : () => { handleShowPopUp() }}
                    iconName='download-outline'
                    show='SURVEY'
                    type='SURVEY'
                    textTop='0'
                    isGradient={true}
                    sz={25}
                />
            </View>

            <Modal
                isVisible={PopUpvisible}
                deviceWidth={width}
                deviceHeight={height}
                hasBackdrop={true}
                backdropColor={colors.background_approved}
                backdropOpacity={0.9}
                onBackdropPress={() => { showPopUp() }}
                onRequestClose={() => { showPopUp() }}
            >
                <SafeAreaView
                    style={styles.main}>
                    <CustomLabel
                        value={t('common:importAssm')}
                        type='MINORTITLE'
                    />

                    <SafeAreaView style={styles.dropDownView}>
                        <CustomDropDownWithIcons
                            defValue={selected}
                            options={assmList}
                            value={selected}
                            setValue={(e) => { setselected(e) }}
                            type='FULL'
                        />
                    </SafeAreaView>
                    <SafeAreaView style={styles.buttons}>
                        <SafeAreaView style={styles.row}>
                            <CustomButton
                                onPress={() => { showPopUp() }}
                                iconName='close-outline'
                                show='HOME_BELL'
                                type='HOME_BELL'
                                textTop='0'
                                sz={30}
                            />
                            <CustomButton
                                onPress={() => { handleCopyAssm() }}
                                iconName='checkmark-outline'
                                show='HOME_BELL'
                                type='HOME_BELL'
                                textTop='0'
                                sz={30}
                            />
                        </SafeAreaView>
                    </SafeAreaView>
                </SafeAreaView>
            </Modal>
        </SafeAreaView>
    )

}

const makeStyles = (colors) => StyleSheet.create({
    main: {

        justifyContent: 'center',
    },
    dropDownView: {
        margin: 20,
    },
    buttons: {
        alignSelf: 'flex-end',

    },
    row: {
        alignItems: 'center',
        flexDirection: 'row',
    },
    rowBtn: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'flex-start',
    },

});
export default PopUpAssm;


